<template>
  <div class="view-club-main">
    <el-table @row-click="expandRow" ref="refTable"  :data="tableData">
      <el-table-column type="expand">
        <template slot-scope="{row}">
          <el-form label-position="left" class="row" label-width="110px">
            <el-form-item label="时间">
              {{ row.created_at|parseTime}}
            </el-form-item>
            <el-form-item label="标题">
              {{ row.title}}
            </el-form-item>
            <el-form-item label="总赞数">
              {{ row.like_sum}}
            </el-form-item>
            <el-form-item label="留言数">
              {{ row.comment_sum}}
            </el-form-item>
            <el-form-item label="浏览数">
              {{ row.read_sum}}
            </el-form-item>
            <el-form-item label="报告简介">
              {{ row.content}}
            </el-form-item>
            <el-form-item label="视频">
              <img :src="preViewUrl+row.thumb" @click="handleShowVideo(preViewUrl+row.video_url)" style="width: 240px;height: 140px;cursor: pointer;border-radius: 5px">
            </el-form-item>
            <el-form-item label="人物头像">
              <img :src="preViewUrl+row.author_avatar" style="height: 60px;width: 60px;border-radius: 100%">
            </el-form-item>
            <el-form-item label="人物名称">
              {{row.author_name}}
            </el-form-item>
            <el-form-item label="人物简介">
              {{row.author_summary}}
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column width="200px" label="时间">
        <template slot-scope="{row}">
          {{ row.created_at|parseTime}}
        </template>
      </el-table-column>
      <el-table-column label="标题" width="400px" prop="title"></el-table-column>
      <el-table-column label="浏览数" width="200px" prop="read_sum"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="{row}">
          <axj-button-v2
            button-color="bread"
            button-size="medium"
            button-icon="del1"
            @click="handleDelete(row.id)"
          ></axj-button-v2>
          <axj-button-v2
            @click="handleUpdate(row.id)"
            button-icon="edit1"
          ></axj-button-v2>
        </template>
      </el-table-column>
    </el-table>
    <view-video
      :video-src="video.src"
      :show.sync="video.show"
    />
  </div>
</template>

<script>
import commonModels from '@/common/models/common-models'
import ViewVideo from "./video/index";
export default {
  name: "view-club-main",
  components: {ViewVideo},
  props:{
    data:{
      type:Array,
      default:[]
    }
  },
  methods:{
    handleDelete(id){
      this.$emit("delete",id)
    },
    handleUpdate(v){
      this.$emit('update',v)
    },
    handleShowVideo(url){
      this.video.show=true
      this.video.src=url
    },
    expandRow(row,index,e){
      let target=e.target
      if(target.className.indexOf('cell')==0||target.className.indexOf('el-tag')==0||target.className.indexOf('el-table')==0){
        this.$refs.refTable.toggleRowExpansion(row)
        return
      }
    },
  },
  data(){
    return{
      video:{
        src:undefined,
        show:false
      }
    }
  },
  computed:{
    tableData(){
      return this.data
    },
    preViewUrl(){
      return this.$common.SystemConfig.PreViewUrl
    }
  },
  filters: {
    parseTime(time) {
      return commonModels.formatTime(time, 'Y/M/D h:m:s')
    },
  }
}
</script>

<style slot-scope lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/axj-information/axj-view-club/component/view-club-main/index.vue